import { useOnboardingStore } from "../../store/onboarding";
import { useNotifications } from "../../store/useNotifications";

const POLL_INTERVAL_MS = 20000;

/**
 * Опрашивает чек-лист квестов на предмет новых завершений и раздаёт наградные
 * уведомления (ТЕСТ ОНБОРДИНГ 2, «Добавить наградные уведомления»): тост — по
 * умолчанию и для item.notificationType === "toast", модалка — для "modal".
 * Реалтайм-канала на бэкенде `onboarding` нет (см. Global Constraints плана)
 * — только поллинг.
 */
export function useOnboardingRewardWatcher() {
  const onboardingStore = useOnboardingStore();
  const notifications = useNotifications();

  let intervalId: ReturnType<typeof setInterval> | null = null;
  let knownCompletedIds = new Set<string>();
  let armed = false;

  function seedKnownCompleted() {
    knownCompletedIds = new Set(
      onboardingStore.items.filter((item) => item.status === "completed").map((item) => item.id),
    );
  }

  function dispatchNewlyCompleted() {
    for (const item of onboardingStore.items) {
      if (item.status !== "completed" || knownCompletedIds.has(item.id)) continue;
      knownCompletedIds.add(item.id);

      if (item.notificationType === "modal") {
        onboardingStore.enqueueRewardModal(item);
      } else {
        notifications.notifyReward({ questId: item.id, questName: item.name, amount: item.rewardAmount }, () =>
          onboardingStore.requestOpen(item.id),
        );
      }
    }
  }

  async function poll() {
    await onboardingStore.load(true);
    if (!armed) {
      if (onboardingStore.status === "ready") {
        seedKnownCompleted();
        armed = true;
      }
      return;
    }
    dispatchNewlyCompleted();
    if (onboardingStore.items.length > 0 && onboardingStore.items.every((item) => item.status === "completed")) {
      stop();
    }
  }

  async function start() {
    if (intervalId) return;
    await onboardingStore.load();
    if (onboardingStore.status === "ready") {
      seedKnownCompleted();
      armed = true;
    }
    intervalId = setInterval(() => void poll().catch(() => {}), POLL_INTERVAL_MS);
  }

  function stop() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    armed = false;
  }

  return { start, stop };
}
